// extracted by mini-css-extract-plugin
export var highlightFade = "_35-4";
export var highlighted = "_35-3";
export var table = "_35-1";
export var tableContainer = "_35-0";
export var totalsRow = "_35-2";